import React, { useRef, useState, Suspense, useEffect } from 'react'
import { Canvas } from '@react-three/fiber'
import { PresentationControls } from '@react-three/drei'

import { VscCircuitBoard } from "react-icons/vsc"
import { FaSpinner } from "react-icons/fa"
import {BsChevronBarContract,BsChevronBarExpand} from 'react-icons/bs'

import { Transition } from '@headlessui/react'

import G20, { ToSelect } from './G20_Anim_v2'

import {LoadingJ4C} from './components'



const Scene = React.forwardRef(({ ...props }, ref) => {
  return (
    <PresentationControls global zoom={0.8} rotation={[0, -Math.PI / 4, 0]} polar={[0, Math.PI / 4]} azimuth={[-Infinity, Infinity]}>
      <group position-y={-0.75} dispose={null}>
        <G20 ref={ref} endCallback={props.endCallback} />
      </group>
    </PresentationControls>
  )
})




export default function App() {

  const myRef = useRef()

  const [toggleAssembly, setToggleAssembly] = useState(true)
  const [animProgress, setAnimProgress] = useState(false)
  const [selectedItem, setSelectedItem] = useState(0)

  const obj = {
    disassembly: {
      fun: () => { myRef.current.assembly(); setAnimProgress(true);myRef.current.selectItem(null);setSelectedItem(0) },
      Icon: BsChevronBarContract
    },
    assembly: {
      fun: () => { myRef.current.play(); setAnimProgress(true); },
      Icon:  BsChevronBarExpand
    },
    select: {
      fun: (key) => { myRef.current.selectItem(key); setSelectedItem(key); }
    }
  }


  useEffect(() => {
    console.log(myRef);
  }, [])


  return (
    <section className="bg-gradient-to-bl from-[#0E1C1F] via-[#172530] to-[#0D1B1E] h-screen pt-5 pb-5">
      <section className="container mx-auto flex flex-row rounded ring-2 ring-gray-600 ring-opacity-30 h-full p-10">
        <section className="basis-1/4">
          <h1 className="text-2xl font-extrabold mb-4">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="logo" className='w-20' />
          </h1>
          <h2 className="text-2xl font-bold mb-2">G20 <span className='text-sm'>Gaźnik</span></h2>
          
          
          <Transition
        show={!toggleAssembly}
        enter="transform transition duration-[400ms]"
          enterFrom="opacity-0 rotate-[-120deg] scale-50"
          enterTo="opacity-100 rotate-0 scale-100"
          leave="transform duration-200 transition ease-in-out"
          leaveFrom="opacity-100 rotate-0 scale-100 "
          leaveTo="opacity-0 scale-95 "
      >
          
          <div class="flex flex-col space-y-4">

            {Object.keys(ToSelect).map((k, i) => (

              <a class={`relative inline-block px-8 py-3 overflow-hidden  ${(k===selectedItem) ? "pointer-events-none" : ""} border border-gray-600 group`}  href={`#${i}`} key={i} onClick={() => {if(!animProgress) obj.select.fun(k) }}>
                <span class={`absolute inset-y-0 left-0 w-[2px]  bg-gray-600  ${(k===selectedItem) ? "w-2 bg-red-600" : "transition-all group-hover:w-full"}`}></span>
                <span class={`relative text-sm font-medium text-gray-600 transition-colors ${(k===selectedItem) ? "text-white" : ""} group-hover:text-white`}>
                  <VscCircuitBoard className="float-left mr-3 mt-1" />
                  {ToSelect[k].name}
                </span>
              </a>
              
            ))}
           
          </div>
          </Transition>
        </section>
        <section className="basis-3/4 relative">
          
          <Suspense fallback={<LoadingJ4C />}>
            <Canvas >
              <Scene ref={myRef} endCallback={() => { setToggleAssembly(toggleAssembly => !toggleAssembly); setAnimProgress(animProgress => !animProgress); }} />
            </Canvas>
          </Suspense>
          <button disabled={animProgress} onClick={toggleAssembly ? obj.assembly.fun : obj.disassembly.fun} className='absolute right-0 bottom-0 border border-gray-600 p-2 hover:bg-gray-600 hover:text-white'>{animProgress ? <FaSpinner size={24} className={`animate-spin`} />: toggleAssembly ? <obj.assembly.Icon size={24} /> : <obj.disassembly.Icon size={24} />}</button>
        </section>
      </section>

    </section>

  )
}